import moment from 'moment';
import { getPreviousDate, getShortDayMonthYear } from '../utils/dateUtils';
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthsWithKeyValue = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
};

const getDateWithPrefixZero = riskScoreDate => {
  let {
    dd,
    mm,
    yy
  } = getShortDayMonthYear(riskScoreDate);

  if (dd < 10) {
    dd = '0' + dd;
  }

  if (mm < 10) {
    mm = '0' + mm;
  }

  return mm + '/' + dd + '/' + yy;
};

const setDefaultTrendLine = trendData => {
  let todaysDate = moment();
  var currentMonth = moment();
  var prevMonth = todaysDate;
  prevMonth = moment(prevMonth).subtract(1, 'months').startOf('day');
  let monthlyData = [];
  let monthlyLabels = [];
  trendData && trendData.map(value => {
    let date1 = getPreviousDate(prevMonth);
    let date2 = getPreviousDate(currentMonth);
    var currentDate = getPreviousDate(value.riskScoreDate);
    let today = getDateWithPrefixZero(value.riskScoreDate);

    if (currentDate >= date1 && currentDate <= date2) {
      monthlyData.push(value.riskScore);
      monthlyLabels.push(today);
    }
  });
  return {
    monthlyData,
    monthlyLabels
  };
};

const getYearMonthTrendLinesLabelsAndData = (trendData, todaysDate, trend, monthNames) => {
  let monthData = [];
  todaysDate = moment();
  let numberOfMonths = 0;

  switch (trend) {
    case '6M':
      numberOfMonths = 6;
      break;

    case '1Y':
      numberOfMonths = 12;
      break;

    default:
      numberOfMonths = 18;
  }

  for (let i = 0; i < numberOfMonths; i++) {
    let format = trend === '1Y' || trend === 'All' ? 'UTC' : null;
    let {
      mm,
      yy
    } = getShortDayMonthYear(todaysDate, format);
    monthData.push(monthNames[mm - 1] + ' ' + yy);
    todaysDate = moment(todaysDate).subtract(1, 'months').startOf('month');
  }

  var Data = [];
  var Labels = [];

  for (let i = monthData.length - 1; i >= 0; i--) {
    trendData && trendData.map(d => {
      let {
        dd,
        mm,
        yy
      } = getShortDayMonthYear(d.riskScoreDate);
      var m = monthData[i].split(' ');

      if (m[0] == monthNames[mm - 1] && m[1] == yy) {
        Data.push(d.riskScore);
        Labels.push(dd + '-' + monthData[i]);
      }
    });
  }

  return {
    Data,
    Labels
  };
};

const getMonthWeekTrendLinesLabelsAndData = (overallTrendData, todaysDate, trend) => {
  var presentMonth = moment().toLocaleString();
  var month = todaysDate;

  switch (trend) {
    case '1M':
      month = moment(month).subtract(1, 'months').startOf('day');
      break;

    case '1W':
      month = moment(month).subtract(7, 'days').startOf('day');
      break;

    default:
      break;
  }

  let Data = [];
  let Labels = [];
  overallTrendData && overallTrendData.map(value => {
    var date1 = getPreviousDate(month);
    var date2 = getPreviousDate(presentMonth);
    var currentDate = getPreviousDate(value.riskScoreDate);
    let today = getDateWithPrefixZero(value.riskScoreDate);

    if (currentDate >= date1 && currentDate <= date2) {
      Data.push(value.riskScore);
      Labels.push(today);
    }
  });
  return {
    Data,
    Labels
  };
};

const setTrendsLineData = (state, trendsData) => {
  let monthNames = months;
  var todaysDate = moment().toLocaleString();

  if (!state.trend) {
    const {
      monthlyData,
      monthlyLabels
    } = setDefaultTrendLine(trendsData);
    state.dataLine.datasets[0].data = monthlyData;
    state.dataLine.labels = monthlyLabels;
  } else if (state.trend == '6M' || state.trend == '1Y' || state.trend == 'All') {
    const {
      Data,
      Labels
    } = getYearMonthTrendLinesLabelsAndData(trendsData, todaysDate, state.trend, monthNames);
    state.dataLine.datasets[0].data = Data;
    state.dataLine.labels = Labels;
  } else if (state.trend == '1M' || state.trend == '1W') {
    const {
      Data,
      Labels
    } = getMonthWeekTrendLinesLabelsAndData(trendsData, todaysDate, state.trend);
    state.dataLine.datasets[0].data = Data;
    state.dataLine.labels = Labels;
  }
};

const getDataLine = () => {
  return {
    labels: [],
    scaleShowVerticalLines: false,
    datasets: [{
      borderColor: '#53A6E1',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#53A6E1',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 2,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#53A6E1',
      pointHoverBorderColor: '#53A6E1',
      pointHoverBorderWidth: 2,
      pointRadius: 0.5,
      pointHitRadius: 50,
      backgroundColor: 'rgb(84, 167, 226, .2)',
      data: []
    }]
  };
};

export { months, monthsWithKeyValue, setDefaultTrendLine, getYearMonthTrendLinesLabelsAndData, getMonthWeekTrendLinesLabelsAndData, setTrendsLineData, getDataLine };